import { render, staticRenderFns } from "./SettingsTab.vue?vue&type=template&id=5657492a&"
import script from "./SettingsTab.vue?vue&type=script&lang=js&"
export * from "./SettingsTab.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTab.vue?vue&type=style&index=0&id=5657492a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports